import { Divider, Icon } from "@blueprintjs/core"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { MediumText } from "../../../../styled/text.styled"
import { Instrument } from "../types"
import InstrumentCard from "./InstrumentCard"
import { HeaderContainer, InstrumentsCardList, InstrumentsContainer } from "./Instruments.styled"

interface IInstrumentsProps {
  instruments: Instrument[]
}

const Instruments = ({ instruments }: IInstrumentsProps) => (
  <InstrumentsContainer flexDirection="column" gap="5px">
    <Divider />

    <HeaderContainer gap="25px" justifyContent="space-between">
      <FlexContainer gap="25px">
        <Icon icon="list" size={22} />
        <MediumText>Instruments</MediumText>
      </FlexContainer>
    </HeaderContainer>

    <InstrumentsCardList compact>
      {instruments.map((instrument, index) => (
        <InstrumentCard key={index} index={index} instrument={instrument} />
      ))}
    </InstrumentsCardList>
  </InstrumentsContainer>
)

export default Instruments
